export default {
	tenantId: "dlvn_uat",
	appId: "covergo_crm",
	fileSystem: {
		bucketName: "dlvn--uat"
	}
}
